module.exports = __webpack_public_path__ + "static/img/AI.125ddab5.png";